(() => {
  const selector = '.bm-new-card__media > .bm-inventory-card__image--primary';
  const bounds = new WeakMap();
  const observed = new WeakSet();
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = 96;
  const context = canvas.getContext('2d', { willReadFrequently: true });
  if (!context || typeof ResizeObserver !== 'function') return;
  function measure(image) {
    image.style.removeProperty('--bm-wheel-scale');
    image.style.removeProperty('--bm-wheel-x');
    image.style.removeProperty('--bm-wheel-y');
    if (!image.complete || !image.naturalWidth || !image.naturalHeight) return;
    try {
      context.clearRect(0, 0, 96, 96);
      context.drawImage(image, 0, 0, 96, 96);
      const { data } = context.getImageData(0, 0, 96, 96);
      const ink = (x, y) => {
        const i = (y * 96 + x) * 4;
        return data[i + 3] > 32 && Math.min(data[i], data[i + 1], data[i + 2]) < 238;
      };
      if ([[0,0],[95,0],[0,95],[95,95]].some(([x,y]) => ink(x,y))) return;
      let left=96, top=96, right=-1, bottom=-1;
      for (let y=0;y<96;y++) for(let x=0;x<96;x++) {
        if (ink(x,y)) { left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y); }
      }
      if (right-left < 32 || bottom-top < 32) return;
      bounds.set(image, { left:Math.max(0,left-1)/96, top:Math.max(0,top-1)/96, right:Math.min(96,right+2)/96, bottom:Math.min(96,bottom+2)/96 });
      position(image);
    } catch {
      bounds.delete(image);
      canvas.width = 96;
    }
  }
  function position(image) {
    const box = bounds.get(image);
    if (!box) return;
    const style=getComputedStyle(image);
    const width=image.clientWidth-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight);
    const height=image.clientHeight-parseFloat(style.paddingTop)-parseFloat(style.paddingBottom);
    if (width <= 0 || height <= 0) return;
    const fit=Math.min(width/image.naturalWidth,height/image.naturalHeight);
    const renderedWidth=image.naturalWidth*fit, renderedHeight=image.naturalHeight*fit;
    const scale=Math.min(1.55, width*0.94/(renderedWidth*(box.right-box.left)), height*0.94/(renderedHeight*(box.bottom-box.top)));
    image.style.setProperty('--bm-wheel-scale',scale.toFixed(4));
    image.style.setProperty('--bm-wheel-x',(-((box.left+box.right)/2-0.5)*renderedWidth*scale).toFixed(2)+'px');
    image.style.setProperty('--bm-wheel-y',(-((box.top+box.bottom)/2-0.5)*renderedHeight*scale).toFixed(2)+'px');
  }
  const resize=new ResizeObserver(entries => entries.forEach(({target}) => position(target)));
  function register(image) {
    if (!observed.has(image)) { observed.add(image);resize.observe(image); }
    bounds.delete(image);
    measure(image);
  }
  document.addEventListener('load',event => {
    if (event.target instanceof HTMLImageElement && event.target.matches(selector)) register(event.target);
  },true);
  function scan(root) {
    if (root instanceof Element && root.matches(selector)) register(root);
    root.querySelectorAll?.(selector).forEach(register);
  }
  scan(document);
  new MutationObserver(records => records.forEach(record => {
    record.addedNodes.forEach(node => { if (node instanceof Element) scan(node); });
  })).observe(document.body,{childList:true,subtree:true});
})();